// 导出excel
export default function useDownload(url: string) {
  const a: HTMLAnchorElement = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.download = "";
  a.click();
  a.remove();
}

// 下载附件
